module.exports = __webpack_public_path__ + "static/img/temp-style@m.85b2160.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-style@m.png
// module id = m9qD
// module chunks = 0